import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { AutoLoginGuard } from './guards/auto-login.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
    canLoad: [AutoLoginGuard] // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule),
    canActivate: [AuthGuard] // Use canActivate to protect account route
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
    // canLoad: // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'error',
    loadChildren: () => import('./pages/error-page/error-page.module').then(m => m.ErrorPageModule),
    // canLoad: // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'success',
    loadChildren: () => import('./pages/success-page/success-page.module').then(m => m.SuccessPageModule),
    // canLoad: // Use canAc tivate to prevent access to login if already logged in
  },
  {
    path: 'ref/:refCode',
    loadChildren: () => import('./pages/invite/referral/referral.module').then(m => m.ReferralModule),
    // canLoad: [AutoLoginGuard] // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'download',
    loadChildren: () => import('./pages/invite/download-app/download-app.module').then(m => m.DownloadAppModule),
    // canLoad: [AutoLoginGuard] // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'legal',
    loadChildren: () => import('./pages/legal/legal.module').then(m => m.LegalModule),
    // canLoad: [AutoLoginGuard] // Use canActivate to prevent access to login if already logged in
  },
  {
    path: 'gift-card',
    loadChildren: () => import('./pages/gift-card-guest/gift-card-guest.module').then(m => m.GiftCardGuestModule),
  },
  {
    path: 'invite/join/:joinCode',
    loadChildren: () => import('./pages/invite/join-plan/join-plan.module').then(m => m.JoinPlanModule),
    // canLoad: [AutoLoginGuard] // Use canActivate to prevent access to login if already logged in
  },
  {
    path: '**',
    redirectTo: 'account',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
